import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-benefits-banner',
  templateUrl: './benefits-banner.component.html',
  styleUrls: ['./benefits-banner.component.scss']
})
export class BenefitsBannerComponent implements OnInit {
  public loggedIn:boolean;
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public AustraliaTimeZone:boolean = false;
  public HongKongTimeZone:boolean = false;
  public UAETimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private timezoneService: TimeZoneService
  ) {
    this.authenticationService.loggedIn.subscribe(state=>{
      this.loggedIn = state;
    })
  }

  ngOnInit() {
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
  }

}
